export default "__VITE_ASSET__DnMJSArs__"